var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"root-breadcrumb"},[_c('ol',[_vm._l((_vm.links),function(item,index){return [_c('li',{key:index},[_c('router-link',{staticClass:"link",attrs:{"to":item.to || '#'}},[_vm._v(_vm._s(item.title))])],1)]}),(_vm.lastItem)?_c('li',[_vm._v(_vm._s(_vm.lastItem.title))]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }